module.exports = __webpack_public_path__ + "img/effects-6.d9f173e5.png";